<template>
  <v-progress-circular
    class="naj-loader"
    indeterminate
    :color="color"
  ></v-progress-circular>
</template>

<script>
export default {
  name: 'NajLoader',
  props: { color: { default: 'primary' } },
};
// todo: TS PART
// import { Component, Prop, Vue } from 'vue-property-decorator';

// @Component
// export default class NajLoader extends Vue {
//   @Prop({ default: 'primary' }) private color!: string;
// }
</script>

<style scoped>
.naj-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.5);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
